import apiClient from '@/services/api';

export interface MasterPasswordStatus {
    is_set: boolean;
    updated_at: string | null;
}

export interface MasterPasswordUsageLogEntry {
    id: string;
    student_user_id: string;
    enrollment_number: string;
    ip_address: string | null;
    user_agent: string | null;
    created_at: string;
}

const unwrap = <T,>(res: { data: { data: T } }): T => res.data.data;

const masterPasswordService = {
    /** Super Admin only. Never returns the password itself — only whether one is set. */
    getStatus: async (): Promise<MasterPasswordStatus> =>
        unwrap(await apiClient.get('/admin/settings/master-password')),

    /** Sets or replaces the master password. Applies to every student login immediately. */
    setPassword: async (password: string): Promise<MasterPasswordStatus> =>
        unwrap(await apiClient.put('/admin/settings/master-password', { password })),

    /** Clears the master password — disables master-password student login entirely. */
    clearPassword: async (): Promise<MasterPasswordStatus> =>
        unwrap(await apiClient.delete('/admin/settings/master-password')),

    /** Audit trail: recent student logins that used the master password instead of their own. */
    getUsageLog: async (): Promise<MasterPasswordUsageLogEntry[]> =>
        unwrap(await apiClient.get('/admin/settings/master-password/usage-log')),
};

export default masterPasswordService;
